<template>
  <div>
    <PageLoader v-bind:storage="appLoading" v-bind:contain="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#3EA56E" left :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12>
        <v-layout wrap justify-center>
          <v-flex xs11 sm7>
            <v-layout wrap>
              <v-flex xs12 text-left py-5>
                <h3>Cart</h3>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-center>
              <v-flex xs12>
                <v-card elevation="3" width="800px" class="mx-auto">
                  <v-layout wrap pa-2>
                    <v-flex sm12 md7 lg7>
                      <v-layout wrap>
                        <v-flex xs12 text-left>
                          <span class="deliver">Deliver to:</span>
                          <span class="name">George William</span>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <v-layout wrap>
                            <v-flex xs8>
                              <span class="deliver"
                                >ABC Avenue, street2, Idukki</span
                              >
                            </v-flex>
                            <v-flex xs4>
                              <span class="deliver">Ph:88787878787</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex sm12 md5 lg5 text-right class="hidden-sm-and-down">
                      <v-layout wrap justify-center>
                        <v-flex align-self-center pt-3>
                          <span class="change">CHANGE</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex sm12 lg5 text-center class="hidden-md-and-up">
                      <v-layout wrap justify-center>
                        <v-flex align-self-center pt-3>
                          <span class="change">CHANGE</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout wrap pt-5>
              <v-flex xs12 py-4 v-for="(item, i) in cart" :key="i">
                <v-layout wrap>
                  <v-flex xs3>
                    <v-card flat>
                      <v-img
                        contain
                        width="150px"
                        :src="require('../../../assets/Images/' + item.image)"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="#3EA56E"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-card>
                  </v-flex>
                  <v-flex xs4>
                    <v-layout wrap text-left>
                      <v-flex xs12 align-self-center pt-md-5 pl-3>
                        <span
                          ><strong>{{ item.title }}</strong></span
                        >
                      </v-flex>
                      <v-flex xs12 align-self-center pl-3>
                        <span class="sub">{{ item.subtitle }}</span>
                      </v-flex>
                      <v-flex xs12 align-self-center pl-3>
                        <span
                          ><v-icon small>mdi-currency-inr</v-icon>
                          <strong>{{ item.price }}</strong> &nbsp;
                          <span class="old"
                            ><strike>{{ item.oldprice }}</strike></span
                          >
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs5>
                    <v-layout wrap>
                      <v-flex xs12 text-right class="hidden-sm-and-down">
                        <v-btn outlined><v-icon small>mdi-minus</v-icon></v-btn>
                        <v-btn outlined width="100px">1</v-btn>
                        <v-btn outlined><v-icon small>mdi-plus</v-icon></v-btn>
                      </v-flex>
                      <v-flex xs12 text-right class="hidden-md-and-up">
                        <v-flex xs12>
                          <v-btn outlined small
                            ><v-icon small>mdi-minus</v-icon></v-btn
                          >
                        </v-flex>
                        <v-flex xs12>
                          <v-btn outlined small>1</v-btn>
                        </v-flex>
                        <v-flex xs12>
                          <v-btn outlined small
                            ><v-icon small>mdi-plus</v-icon></v-btn
                          >
                        </v-flex>
                      </v-flex>
                      <v-flex xs12 text-right>
                        <v-btn icon
                          ><v-icon small color="grey">mdi-delete</v-icon></v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-flex xs12 pt-3>
                  <v-divider></v-divider>
                </v-flex>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 py-6>
                <v-layout wrap>
                  <v-flex sm6>
                    <v-layout wrap>
                      <v-flex xs12 text-left>
                        <span class="total">TOTAL</span>
                      </v-flex>
                      <v-flex xs12 text-left pt-4>
                        <span class="price">Rs. 1500</span>
                      </v-flex>
                      <v-flex xs12 text-left>
                        <span class="sub"
                          >Shipping&taxes Calculated at checkout</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6>
                    <v-layout wrap text-right>
                      <v-flex xs12 pr-5>
                        <span class="sub">3 items selected for order</span>
                      </v-flex>
                      <v-flex xs12 pt-4>
                        <v-btn width="200px" dark color="#3EA56E"
                          >Place Order</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      ServerError: false,
      cart: [
        {
          image: "c2.png",
          title: "ABC Indoor Plant",
          subtitle: "Indoor Plant",
          price: "280",
          oldprice: "340",
        },
        {
          image: "c7.png",
          title: "ABC Indoor Plant",
          subtitle: "Indoor Plant",
          price: "280",
          oldprice: "340",
        },
        {
          image: "c4.png",
          title: "ABC Indoor Plant",
          subtitle: "Indoor Plant",
          price: "280",
          oldprice: "340",
        },
      ],
    };
  },
};
</script>

<style scoped>
.change {
  color: red;
  font-size: 13px;
}
.deliver {
  font-size: 13px;
  color: grey;
}
.sub {
  font-size: 13px;
  color: grey;
}
.v-btn--outlined {
  border-radius: unset;
  border-color: rgb(202, 199, 199);
}
.price {
  font-size: 20px;
  font-weight: bolder;
}
.old {
  color: grey;
}
.total {
  color: grey;
  font-size: 16px;
  letter-spacing: 2px;
}
.name {
  font-size: 15px;
  font-weight: bold;
}
</style>